import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=57ef2bbe"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ef2bbe')) {
      api.createRecord('57ef2bbe', component.options)
    } else {
      api.reload('57ef2bbe', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=57ef2bbe", function () {
      api.rerender('57ef2bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/Search.vue"
export default component.exports